import React from 'react'
import styles from './styles.module.scss'
import PropTypes from 'prop-types'

function PillPure({
  type,
  text,
  size,
  count,
  dataId,
  selected,
  selectedForRemoval,
  lastInterestRef,
  className,
  onClick,
  handleMouseEnter,
  handleMouseLeave,
  handleKeyUp,
  renderSelected,
  renderUnselected,
  renderShared,
  showIcon
}) {
  return (
    <button
      type='button'
      title={selectedForRemoval ? text : ''}
      data-id={dataId}
      ref={lastInterestRef}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : { cursor: 'default' }}
      onKeyUp={handleKeyUp}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`${styles.pill} ${styles[size]} ${count > 0 && styles.withCount} ${
        selected ? styles.selected : selectedForRemoval ? styles.selectedForRemoval : styles.normal
      } ${`${type === 'expertise' ? styles.expertisePill : ''} ${className}`} ${!showIcon && styles.pillWithoutIcon}`}>
      {/* {selectedForRemoval && renderIcon ? renderIcon() : null} */}
      {count > 0 ? count : null}
      {showIcon
        ? renderShared
          ? renderShared()
          : renderSelected
          ? renderSelected()
          : renderUnselected
          ? renderUnselected()
          : null
        : null}

      {text ? <span dangerouslySetInnerHTML={{ __html: text }} /> : ''}
    </button>
  )
}

PillPure.propTypes = {
  text: PropTypes.string,
  size: PropTypes.string,
  count: PropTypes.number,
  showIcon: PropTypes.bool,
  shared: PropTypes.bool,
  selected: PropTypes.bool,
  selectedForRemoval: PropTypes.bool,
  onClick: PropTypes.func,
  lastInterestRef: PropTypes.object,
  dataId: PropTypes.number,
  onKeyUp: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  renderIcon: PropTypes.func
}

PillPure.defaultProps = {
  size: 'small',
  showIcon: true
}

export default PillPure
